import { useIntl } from 'react-intl'

import { SxProps, Theme, Tooltip } from '@mui/material'
import Link, { LinkProps } from '@mui/material/Link'
import { ReactComponent as ChevronRightIcon } from 'assets/icons/ChevronRight.svg'

const linkStyle: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  '&:hover': {
    bgcolor: 'inherit',
    textDecoration: 'underline',
  },
  '&:not(:last-child)': { mr: 2.4 },
  '& svg': {
    width: 'auto',
    height: '2.4rem',
    ml: 0.8,
  },
}

const CustomLink = ({ children, href, ...otherProps }: LinkProps) => {
  const { formatMessage } = useIntl()
  return (
    <Tooltip
      title={otherProps.target === '_blank' ? formatMessage({ id: 'message.new_page_link' }) : null}
      disableHoverListener
      disableTouchListener
    >
      <Link href={href} variant="body2" color="text.secondary" sx={linkStyle} {...otherProps} tabIndex={0}>
        {children}
        <ChevronRightIcon />
      </Link>
    </Tooltip>
  )
}

export default CustomLink
